import React from 'react';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import appConfig from '../../../../appConfig';
import PortalSessionContext from '../../../../contexts/PortalSessionContext/PortalSessionContext';
import { UserStatus } from '../../../../constants/user';
import { PlayupExclusionDescription, StateExclusionDescription } from './PlayupExclusionDescription';
import SectionSwitcher from '../../SectionSwitcher';
import ResponsibleGambling from '../../../../User/components/ResponsibleGambling';
import PlayupExclusionForm from './PlayupExclusionForm';

dayjs.extend(localizedFormat);
const state = appConfig.regions.usState;

const exclusionNames = {
	IA: 'Iowa Self-Exclusion Program',
	OH: 'Ohio Voluntary Exclusion Program',
};

const sections = [exclusionNames[state] ?? 'State Exclusion Program', 'Playup Self-Exclusion'];

const UsSelfExclusion = () => {
	const [selectedIndex, setSelectedIndex] = React.useState(0);
	const { user } = React.useContext(PortalSessionContext);

	return (
		<div className="_mt-2 md:_mt-6">
			<Helmet title="Self Exclusion" />

			<div className="_max-w-3xl _p-5 _mx-auto _text-gray-700 _bg-white _rounded">
				<h2 className="_font-bold _uppercase _text-2xl _mb-8 _text-center">Self Exclusion</h2>
				<SectionSwitcher options={sections} onSelectIndex={setSelectedIndex} activeIndex={selectedIndex} />

				{selectedIndex === 0 && (
					<>
						<StateExclusionDescription />
					</>
				)}
				{selectedIndex === 1 && (
					<>
						<PlayupExclusionDescription />
						{user?.status?.id === UserStatus.Break ? (
							<div className="_px-2 _py-4 _text-sm _text-center _text-blue-600 _bg-blue-100 _rounded md:_text-base">
								{user.break_applied_at && <p>Requested on {dayjs(user.break_applied_at).format('LL, h:mm A')}</p>}
								{user.break_end_at && <p>Your break ends on {dayjs(user.break_end_at).format('LL, h:mm A')}</p>}
							</div>
						) : (
							<PlayupExclusionForm />
						)}
					</>
				)}

				<ResponsibleGambling />
				<AssistanceText>
					Questions or need Assistance? Contact <a href="mailto:help@playupusa.com">help@playupusa.com</a>
				</AssistanceText>
			</div>
		</div>
	);
};

export default UsSelfExclusion;

const AssistanceText = styled.p`
	margin-bottom: 1rem;
	font-style: italic;
	text-align: center;

	a {
		text-decoration: underline;
	}
`;
